const ContactUs = () => {
    return (

        <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0">
            <div className="container quote px-lg-0">
                <div className="row g-0 mx-lg-0">
                    <div className="col-lg-6 ps-lg-0 wow fadeIn" data-wow-delay="0.1s">
                        <div className="position-relative h-100">
                            <img className="position-absolute img-fluid w-100 h-90" src="img/contactus.png" alt=""></img>
                        </div>
                    </div>
                    <div className="col-lg-6 quote-text py-5 wow fadeIn" data-wow-delay="0.5s">
                        <div className="p-lg-5 pe-lg-0">
                            <h3 className="text-primary">Contact Us</h3>
                            {/*<h1 className="mb-4">Get A Free Quote</h1>*/}
                            <p className="mb-4 pb-2">STEDAX provides comprehensive training for the all components of SARSYS. </p>
                            <p className="mb-4 pb-2">We work closely with our customers as with partners, to ensure they receive a complete understanding of SARSYS and benefits it brings. STEDAX is responsible for successful utilization of SARSYS. </p>
                            <p className="mb-4 pb-2">We always are ready to help.</p>
                            <form>
                                <div className="row g-3">
                                    <div className="col-12 col-sm-6">
                                        <input type="text" className="form-control border-0"
                                               placeholder="Your Name"></input>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <input type="email" className="form-control border-0"
                                               placeholder="Your Email"></input>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <input type="text" className="form-control border-0"
                                               placeholder="Your Mobile"></input>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <select className="form-select border-0">
                                            <option selected>Interested in</option>
                                            <option value="1">Licensing</option>
                                            <option value="2">Manufacturing</option>
                                            <option value="3">Service</option>
                                            <option value="4">Sale</option>
                                            <option value="5">Training and education</option>
                                            <option value="6">Consulting</option>
                                        </select>
                                    </div>
                                    <div className="col-12">
                                        <textarea className="form-control border-0"
                                                  placeholder="Special Note"></textarea>
                                    </div>
                                    <div className="col-12">
                                        <button className="btn btn-primary rounded-pill py-3 px-5"
                                                type="submit">Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ContactUs;